import * as React from 'react';
import { RetrievalResult } from '../../types';
import CurrentResultMessage from './CurrentResultMessage';

import Arrows from '../Arrows';

const EggFreezing = (props: RetrievalResult) => {
  const { eggsRetrieved, eggsFrozen, attemptCompleted } = props;

  return (
    <>
      <h1>Details of retrieval</h1>
      {!attemptCompleted && <CurrentResultMessage />}
      <div>
        <p>
          <strong>{eggsRetrieved}</strong>
          <span>eggs retrieved</span>
        </p>
        <Arrows />
        <p>
          <strong>{eggsFrozen}</strong>
          <span>eggs frozen</span>
        </p>
      </div>
    </>
  );
};

export default EggFreezing;
